<template>
    <section class="skinType">
        <h2>BRAVO!制霸全膚質</h2>
        <div class="skinType__logo1">
            <img src="@/assets/images/skinType__title01.png" class="rwdimg" data-aos="fade-right" alt="BRAVO!制霸全膚質" loading="lazy" />
        </div>
        <div class="skinType__logo2">
            <img src="@/assets/images/skinType__title02.png" class="rwdimg" data-aos="fade-left" alt="全網實證唯一力推精華" loading="lazy" />
        </div>
        <div class="skinType__list">
            <a
                v-for="(skinType, idx) in skinTypeList"
                :key="skinType.author"
                :href="skinType.link"
                target="_blank"
                class="skinType__container"
                data-aos="fade-up"
                @click="gtagEvent(skinType.link, '精華介紹', `${skinType.title}-${skinType.subtitle}`)"
            >
                <h3>
                    <div>{{ skinType.title }} - <span>{{ skinType.subtitle }}</span></div>
                </h3>
                <img :src="imgSrc(`skinType__img0${idx + 1}.png`)" :alt="skinType.author" loading="lazy" />
                <div class="skinType__content">
                    <p>{{ skinType.content }}</p>
                    <div class="skinType__link">
                        <div class="skinType__bottom">
                            部落客{{ skinType.author}}<br class="for-mobile" />老實說
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </section>
</template>

<script setup>
import skinTypeList from '../assets/data/skinType.json';
import gtagEvent from '@/assets/js/gtag';

const imgSrc = imgName => require(`@/assets/images/${imgName}`);



</script>

<style lang="scss" scoped>
@import '@/styles/SkinType';
</style>
